/**
 *  @class
 *  @function Gallery
 */
if (!customElements.get('theme-gallery')) {
  class ThemeGallery extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.galleryVideoList = Array.from(this.querySelectorAll('.gallery--item .gallery__video'));

      this.hoverPlayList = this.galleryVideoList.filter((item) => {
        return item.classList.contains('hover-play') && item;
      });

      this.autoPlayList = this.galleryVideoList.filter((item) => {
        return !item.classList.contains('hover-play') && item;
      });

      this.autoPlayList.forEach((item, i) => {
        item.querySelector('video').play();
      });

      this.setHoverPlayList();
      
      // Custom: Carousel Buttons Option
      this.slideList = Array.from(this.querySelectorAll('.gallery--item'));
      this.innerContainer = this.querySelector('.gallery--inner');
      if(this.classList.contains("swipe-all-devices")){
        this.nextButton = this.querySelector('.gallery-next')
        this.prevButton = this.querySelector('.gallery-prev')
        this.nextButton.addEventListener('click', () => this.scrollByItem('right'));
        this.prevButton.addEventListener('click', () => this.scrollByItem('left'));
      }
      
    }
    setHoverPlayList() {
      this.hoverPlayList.forEach((item, i) => {
        item.querySelector('video').currentTime = 0.1;
        item.parentElement.addEventListener('mouseenter', () => this.playVideo(item));
        item.parentElement.addEventListener('mouseleave', () => this.pauseVideo(item));
      });
    }

    playVideo(videoContainer) {
      videoContainer.querySelector('video').play();
    }
    pauseVideo(videoContainer) {
      videoContainer.querySelector('video').pause();
    }
    scrollByItem(direction) {
      const itemWidth = this.slideList[0].offsetWidth;
      const currentScroll = this.innerContainer.scrollLeft;
      if (direction === 'left') {
         this.innerContainer.scroll({
          behavior: 'smooth',
          left: currentScroll - itemWidth
        });

      } else if (direction === 'right') {
         this.innerContainer.scroll({
          behavior: 'smooth',
          left: currentScroll + itemWidth
        });
      }
    }
  }
  customElements.define('theme-gallery', ThemeGallery);
}